<form [formGroup]="form">
  <mat-form-field2 class="mat-block">
    <mat-label i18n>Incident Name</mat-label>
    <input type="text" i18n-placeholder placeholder="Name of the incident" matInput formControlName="title" required />
    <mat-error *ngIf="form.get('title').hasError('required')" i18n>Incident Name is required</mat-error>
    <mat-error *ngIf="form.get('title').hasError('allNumbers')" i18n>Name cannot be numbers alone.</mat-error>
  </mat-form-field2>
  <div class="row">
    <div class="col-md-6" *ngIf="hideReporterField">
      <mat-form-field2 class="mat-block">
        <app-select
          [items]="users$ | async"
          [formControl]="form.get('reporter_id')"
          bindLabel="name"
          bindValue="id"
          [multiple]="false"
          [searchable]="true"
          [required]="form.get('reporter_id') | required"
          i18n-placeholder
          placeholder="Reporter"
        ></app-select>
        <mat-error *ngIf="form.get('reporter_id').touched && form.get('reporter_id').hasError('required')" i18n>
          Reporter is required
        </mat-error>
      </mat-form-field2>
    </div>
    <div class="col-md-6">
      <mat-form-field2 class="mat-block">
        <app-select
          [items]="users$ | async"
          [formControl]="form.get('reviewer_id')"
          bindLabel="name"
          bindValue="id"
          [multiple]="false"
          [searchable]="true"
          i18n-placeholder
          placeholder="Reviewer"
        ></app-select>
        <mat-error *ngIf="form.get('reviewer_id').touched && form.get('reviewer_id').hasError('required')" i18n>
          Reviewer is required
        </mat-error>
      </mat-form-field2>
    </div>
    <div class="col-md-6">
      <mat-form-field2>
        <mat-select i18n-placeholder placeholder="Severity" formControlName="severity">
          <mat-option *ngFor="let item of severities" [value]="item"> {{ item | titleCase }}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('severity').touched && form.get('severity').hasError('required')" i18n>
          Severity is required
        </mat-error>
      </mat-form-field2>
    </div>
    <div class="col-md-6">
      <mat-form-field2>
        <mat-select i18n-placeholder placeholder="Status" formControlName="status">
          <mat-option *ngFor="let item of statuses" [value]="item"> {{ item | titleCase }}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('status').touched && form.get('status').hasError('required')" i18n>
          Status is required
        </mat-error>
      </mat-form-field2>
    </div>
    <div class="col-md-6">
      <app-select-search
        [items]="categories$ | async"
        [ctrl]="form.get('categories')"
        bindLabel="label"
        bindValue="value"
        [inline]="false"
        [multiple]="true"
        i18n-placeholder
        placeholder="Select Categories"
      >
      </app-select-search>
    </div>
    <div class="col-md-6">
      <app-form-tags
        formControlName="tags"
        label="Tags"
        i18n-matTooltip
        matTooltip="This will allow you to add arbitrary descriptors to this automation record which can then be used when filtering on various reports and calendars."
        matTooltipPosition="above"
      ></app-form-tags>
    </div>
  </div>

  <mat-form-field2 class="mat-block">
    <mat-label i18n>Incident Description</mat-label>
    <textarea
      matInput
      #notes
      maxlength="500"
      rows="3"
      formControlName="description"
      i18n-placeholder
      placeholder="Enter incident details"
      cdkTextareaAutosize
    ></textarea>
    <mat-hint align="end">{{ notes.value?.length || 0 }}/500</mat-hint>
    <mat-error *ngIf="form.get('description').hasError('required')" i18n>Incident description is required</mat-error>
  </mat-form-field2>
  <app-upload-box
    [options]="getUploadBoxOptions()"
    [showFileList]="false"
    *ngIf="!attachments.length"
    (complete)="onUploadComplete($event)"
  ></app-upload-box>
  <div *ngFor="let item of attachments; let i = index" class="d-flex align-items-center gap-3">
    <div class="text-primary text-xxl">
      <i class="" [ngClass]="item.name | fileIcon"></i>
    </div>
    <div class="mr-4">{{ item.name }}</div>
    <div class="flex-fill text-light">
      {{ item.created | epoch : 'DD-MMM-YYYY' }} at {{ item.created | epoch : 'HH:mm' }}* {{ item.user }}*
      {{ item.size | fileSize }}
    </div>
    <div>
      <a href="javascript:;" class="btn btn-light-info btn-sm" (click)="onDownloadAttachment(item)"
        ><i class="cs-icon cs-icon-download"></i>
      </a>
      <a href="javascript:;" class="btn btn-light-danger btn-sm" (click)="onDeleteAttachment(item)"
        ><i class="cs-icon cs-icon-trash"></i>
      </a>
    </div>
  </div>
</form>
